<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">邀请拼多多转盘抽奖</h1>
    <div class="h_search">
      <label>
        是否有效：
        <el-select v-model="search.valid" clearable placeholder="请选择">
          <el-option label="有效" :value="1"></el-option>
          <el-option label="无效" :value="0"></el-option>
        </el-select>
      </label>
      <el-button type="primary" @click="query" :loading="loading">查询</el-button>
      <el-button type="warning" @click="handleAdd">新增</el-button>
    </div>

    <el-table
      :data="datalist"
      style="width: 100%"
      v-loading="loading"
      stripe
      border
    >
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="gear" label="档位"></el-table-column>
      <!-- <el-table-column prop="gearObId" label="档位详情ID"></el-table-column> -->
      <el-table-column prop="reward" label="档位奖励"></el-table-column>
      <el-table-column prop="retentionLeft" label="留存率左区间"></el-table-column>
      <el-table-column prop="retentionRight" label="留存率右区间"></el-table-column>
      <el-table-column label="券的价值">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.lotteryPrice" :key="index">
            {{ getTicketTypeName(item.type) }}: {{ item.price }}钻
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.valid === 1 ? 'success' : 'info'">
            {{ scope.row.valid === 1 ? '有效' : '无效' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            :type="scope.row.valid === 1 ? 'warning' : 'success'"
            @click="handleToggleValid(scope.row)"
          >
            {{ scope.row.valid === 1 ? '设为无效' : '设为有效' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 详情/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="detailDialog"
      width="90%"
      :before-close="handleCloseDetail"
    >
      <el-tabs v-model="activeTab" type="border-card">
        <!-- 基础配置 -->
        <el-tab-pane label="基础配置" name="basic">
          <el-form :model="formData.configData" label-width="150px">
            <el-form-item label="档位">
              <el-input-number v-model="formData.configData.gear" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="档位奖励">
              <el-input v-model="formData.configData.reward"></el-input>
            </el-form-item>
            <el-form-item label="留存率左区间">
              <el-input-number v-model="formData.configData.retentionLeft" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="留存率右区间">
              <el-input-number v-model="formData.configData.retentionRight" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="券的价值">
              <el-button type="primary" size="small" @click="addLotteryPrice">添加券类型</el-button>
              <div v-for="(item, index) in formData.configData.lotteryPrice" :key="index" style="margin-top: 10px">
                <el-select v-model="item.type" placeholder="券类型" style="width: 150px; margin-right: 10px">
                  <el-option
                    v-for="ticketType in ticketTypeList"
                    :key="ticketType.value"
                    :label="ticketType.label"
                    :value="ticketType.value"
                  ></el-option>
                </el-select>
                <el-input-number
                  v-model="item.price"
                  :min="0"
                  placeholder="价值(钻)"
                  style="width: 200px; margin-right: 10px"
                ></el-input-number>
                <el-button type="danger" size="small" @click="removeLotteryPrice(index)">删除</el-button>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <!-- 膨胀阶段配置 -->
        <el-tab-pane label="膨胀阶段配置" name="expand">
          <step-config-form
            v-model="formData.detailData.expandStepConfig"
            :show-expand-lottery="true"
            :rs-list="resourceList"
          ></step-config-form>
        </el-tab-pane>

        <!-- 快速阶段配置 -->
        <el-tab-pane label="快速阶段配置" name="fast">
          <step-config-form
            v-model="formData.detailData.fastStepConfig"
            :rs-list="resourceList"
          ></step-config-form>
        </el-tab-pane>

        <!-- 平稳阶段配置 -->
        <el-tab-pane label="平稳阶段配置" name="stable">
          <step-config-form
            v-model="formData.detailData.stableStepConfig"
            :rs-list="resourceList"
          ></step-config-form>
        </el-tab-pane>

        <!-- 缓慢阶段配置 -->
        <el-tab-pane label="缓慢阶段配置" name="slow">
          <step-config-form
            v-model="formData.detailData.slowStepConfig"
            :rs-list="resourceList"
          ></step-config-form>
        </el-tab-pane>

        <!-- 最终阶段配置 -->
        <el-tab-pane label="最终阶段配置" name="final">
          <step-config-form
            v-model="formData.detailData.finalStepConfig"
            :rs-list="resourceList"
          ></step-config-form>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDetail">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</el-button>
      </div>
    </el-dialog>

    <!-- 奖品列表 -->
    <el-card class="reward-pool-card" style="margin-top: 20px">
      <h2 class="reward-pool-title">奖品列表</h2>
      <CarnivalTable
        :table-list="rewardPoolList"
        :rs-list="resourceList"
        :doc-id="902"
        @open="openDrawer"
      ></CarnivalTable>
    </el-card>

    <!-- 奖品编辑抽屉 -->
    <CarnivalDrawer
      v-model="drawerData.show"
      :config="rewardPoolList"
      @refresh="loadRewardPoolList"
      :doc-id="902"
      :rs-list="resourceList"
      @save="saveRewardPoolConfig"
    ></CarnivalDrawer>
  </el-card>
</template>

<script>
import StepConfigForm from '@/components/StepConfigForm.vue'
import { getConstList } from '@/api/constRequest'
import { getResourceListReq, getCarnivalConfigReq, saveCarnivalConfigReq } from '@/api/carnivalApi'
import CarnivalTable from './StarryConfig/CarnivalTable.vue'
import CarnivalDrawer from './StarryConfig/CarnivalDrawer.vue'

export default {
  components: {
    StepConfigForm,
    CarnivalTable,
    CarnivalDrawer,
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      datalist: [],
      search: {
        valid: null,
      },
      detailDialog: false,
      dialogTitle: '查看详情',
      isEdit: false,
      activeTab: 'basic',
      ticketTypeList: [],
      resourceList: [],
      rewardPoolList: [],
      chapterId: 902,
      drawerData: {
        show: false,
        data: null,
      },
      formData: {
        configData: {
          id: null,
          gear: 0,
          gearObId: '',
          reward: '',
          retentionLeft: 0,
          retentionRight: 0,
          lotteryPrice: [],
          operator: '',
          ctime: 0,
          mtime: 0,
        },
        detailData: {
          id: null,
          expandStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          fastStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          stableStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          slowStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          finalStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          ctime: 0,
          mtime: 0,
        },
      },
    }
  },
  methods: {
    async query() {
      this.loading = true
      try {
        const params = {
          token: this.$store.getters.token,
        }
        if (this.search.valid !== null) {
          params.valid = this.search.valid
        }
        const { data: res } = await this.$axios.get(
          this.$store.getters.path.invite_lottery_query_list,
          { params }
        )
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.datalist = res.data || []
      } catch (error) {
        this.$message.error('查询失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑配置'
      // 先重置表单数据，避免旧数据干扰
      this.resetFormData()
      // 设置基础配置数据
      this.formData.configData = { ...row }
      // 然后加载详情数据（包含各个阶段的配置）
      await this.loadDetail(row.gearObId)
      // 使用 nextTick 确保数据更新后再打开弹窗
      this.$nextTick(() => {
        this.detailDialog = true
      })
    },
    handleAdd() {
      this.isEdit = true
      this.dialogTitle = '新增配置'
      this.resetFormData()
      // 使用 nextTick 确保数据重置后再打开弹窗
      this.$nextTick(() => {
        this.detailDialog = true
      })
    },
    async loadDetail(gearObId) {
      if (!gearObId) {
        this.resetFormData()
        return
      }
      try {
        const { data: res } = await this.$axios.get(
          this.$store.getters.path.invite_lottery_query_detail,
          {
            params: {
              gearObId,
              token: this.$store.getters.token,
            },
          }
        )
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data) {
          // 直接使用接口返回的数据，如果没有则使用默认值
          const defaultDetailData = this.getDefaultDetailData()
          this.formData.detailData = {
            id: res.data.id !== undefined && res.data.id !== null ? res.data.id : defaultDetailData.id,
            expandStepConfig: res.data.expandStepConfig !== undefined && res.data.expandStepConfig !== null 
              ? res.data.expandStepConfig 
              : defaultDetailData.expandStepConfig,
            fastStepConfig: res.data.fastStepConfig !== undefined && res.data.fastStepConfig !== null 
              ? res.data.fastStepConfig 
              : defaultDetailData.fastStepConfig,
            stableStepConfig: res.data.stableStepConfig !== undefined && res.data.stableStepConfig !== null 
              ? res.data.stableStepConfig 
              : defaultDetailData.stableStepConfig,
            slowStepConfig: res.data.slowStepConfig !== undefined && res.data.slowStepConfig !== null 
              ? res.data.slowStepConfig 
              : defaultDetailData.slowStepConfig,
            finalStepConfig: res.data.finalStepConfig !== undefined && res.data.finalStepConfig !== null 
              ? res.data.finalStepConfig 
              : defaultDetailData.finalStepConfig,
            ctime: res.data.ctime !== undefined ? res.data.ctime : defaultDetailData.ctime,
            mtime: res.data.mtime !== undefined ? res.data.mtime : defaultDetailData.mtime,
          }
        }
      } catch (error) {
        this.$message.error('加载详情失败')
        console.error(error)
      }
    },
    async handleSubmit() {
      this.submitLoading = true
      try {
        const url = this.isEdit && this.formData.configData.id
          ? this.$store.getters.path.invite_lottery_update
          : this.$store.getters.path.invite_lottery_add

        const params = {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        }

        // 使用深拷贝确保所有嵌套数据都被正确传递
        const requestData = {
          configData: JSON.parse(JSON.stringify(this.formData.configData)),
          detailData: JSON.parse(JSON.stringify(this.formData.detailData)),
        }

        if (this.isEdit && this.formData.configData.id) {
          requestData.username = this.$store.getters.username
        }

        const { data: res } = await this.$axios.post(url, requestData, { params })
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('保存成功')
        this.handleCloseDetail()
        this.query()
      } catch (error) {
        this.$message.error('保存失败')
        console.error(error)
      } finally {
        this.submitLoading = false
      }
    },
    async handleToggleValid(row) {
      try {
        await this.$confirm(
          `确认将配置${row.valid === 1 ? '设为无效' : '设为有效'}?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.invite_lottery_update_valid,
          {
            id: row.id,
            valid: row.valid === 1 ? 0 : 1,
          },
          {
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
            },
          }
        )
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('操作成功')
        this.query()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('操作失败')
          console.error(error)
        }
      }
    },
    addLotteryPrice() {
      if (!this.formData.configData.lotteryPrice) {
        this.formData.configData.lotteryPrice = []
      }
      this.formData.configData.lotteryPrice.push({
        type: 1,
        price: 0,
      })
    },
    removeLotteryPrice(index) {
      this.formData.configData.lotteryPrice.splice(index, 1)
    },
    getDefaultDetailData() {
      return {
        id: null,
        expandStepConfig: {
          progress: '',
          maxProgress: '',
          expandLotteryCount: 0,
          doubleRewardDetail: {
            rate: 0,
            doubleRewardCount: 0,
            doubleRewardContinuous: 0,
          },
          rewardDetailList: [],
          baseLine: {
            cost: '',
            progress: '',
            maxReward: '',
          },
        },
        fastStepConfig: {
          progress: '',
          maxProgress: '',
          expandLotteryCount: 0,
          doubleRewardDetail: {
            rate: 0,
            doubleRewardCount: 0,
            doubleRewardContinuous: 0,
          },
          rewardDetailList: [],
          baseLine: {
            cost: '',
            progress: '',
            maxReward: '',
          },
        },
        stableStepConfig: {
          progress: '',
          maxProgress: '',
          expandLotteryCount: 0,
          doubleRewardDetail: {
            rate: 0,
            doubleRewardCount: 0,
            doubleRewardContinuous: 0,
          },
          rewardDetailList: [],
          baseLine: {
            cost: '',
            progress: '',
            maxReward: '',
          },
        },
        slowStepConfig: {
          progress: '',
          maxProgress: '',
          expandLotteryCount: 0,
          doubleRewardDetail: {
            rate: 0,
            doubleRewardCount: 0,
            doubleRewardContinuous: 0,
          },
          rewardDetailList: [],
          baseLine: {
            cost: '',
            progress: '',
            maxReward: '',
          },
        },
        finalStepConfig: {
          progress: '',
          maxProgress: '',
          expandLotteryCount: 0,
          doubleRewardDetail: {
            rate: 0,
            doubleRewardCount: 0,
            doubleRewardContinuous: 0,
          },
          rewardDetailList: [],
          baseLine: {
            cost: '',
            progress: '',
            maxReward: '',
          },
        },
        ctime: 0,
        mtime: 0,
      }
    },
    resetFormData() {
      this.formData = {
        configData: {
          id: null,
          gear: 0,
          gearObId: '',
          reward: '',
          retentionLeft: 0,
          retentionRight: 0,
          lotteryPrice: [],
          operator: '',
          ctime: 0,
          mtime: 0,
        },
        detailData: {
          id: null,
          expandStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          fastStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          stableStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          slowStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          finalStepConfig: {
            progress: '',
            maxProgress: '',
            expandLotteryCount: 0,
            doubleRewardDetail: {
              rate: '',
              doubleRewardCount: 0,
              doubleRewardContinuous: 0,
            },
            rewardDetailList: [],
            baseLine: {
              cost: '',
              progress: '',
              maxReward: '',
            },
          },
          ctime: 0,
          mtime: 0,
        },
      }
      this.activeTab = 'basic'
    },
    handleCloseDetail() {
      this.detailDialog = false
      this.resetFormData()
    },
    async loadTicketTypeList() {
      try {
        const res = await getConstList('inviteLotteryTicketPriceType')
        if (res.code === 0 && res.data) {
          this.ticketTypeList = res.data.map(item => ({
            label: item.desc || item.name || `类型${item.value}`,
            value: item.value,
          }))
        }
      } catch (error) {
        console.error('加载抽奖券类型列表失败:', error)
        // 如果加载失败，使用默认值
        this.ticketTypeList = [
          { label: '类型0', value: 0 },
          { label: '类型1', value: 1 },
          { label: '类型2', value: 2 },
          { label: '类型3', value: 3 },
        ]
      }
    },
    async getResourceList() {
      try {
        const res = await getResourceListReq()
        if (res.code === 0) {
          this.resourceList = res.data || []
        } else {
          this.$message.error(res.msg || '加载资源列表失败')
        }
      } catch (error) {
        console.error('加载资源列表失败:', error)
        this.$message.error('加载资源列表失败')
      }
    },
    async loadRewardPoolList() {
      try {
        const res = await getCarnivalConfigReq(this.chapterId)
        if (res.code === 0 && res.data) {
          this.rewardPoolList = res.data.rewardPoolList || []
        }
      } catch (error) {
        console.error('加载奖品列表失败:', error)
      }
    },
    // 获取券类型名称
    getTicketTypeName(type) {
      if (!type && type !== 0) return `类型${type}`
      const ticketType = this.ticketTypeList.find(item => item.value === type)
      return ticketType ? ticketType.label : `类型${type}`
    },
    // 打开奖品编辑抽屉
    openDrawer(isEdit, row) {
      this.drawerData.show = true
    },
    // 保存奖品配置
    async saveRewardPoolConfig(rewardPoolList) {
      try {
        const res = await saveCarnivalConfigReq({
          chapter: this.chapterId,
          rewardPoolList: rewardPoolList,
        })
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.drawerData.show = false
          await this.loadRewardPoolList()
        } else {
          this.$message.error(res.msg || res.message || '保存失败')
        }
      } catch (error) {
        console.error('保存奖品配置失败:', error)
        this.$message.error('保存失败')
      }
    },
  },
  created() {
    this.query()
    this.loadTicketTypeList()
    this.getResourceList()
    this.loadRewardPoolList()
  },
}
</script>

<style scoped>
.title-biaoti {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.h_search {
  margin-bottom: 20px;
}

.h_search label {
  margin-right: 15px;
}

.page-container {
  margin: 20px;
}

.step-config-form {
  padding: 20px;
}

.reward-pool-card {
  margin-top: 20px;
}

.reward-pool-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}
</style>
